import { ATLASSIAN_AUTH_TOKEN } from "../../../common/constants/core/cred.constants";
import { CredentialsReferenceType } from "../../../common/interfaces/flow/action/WebRequestAction";
import CommentIcon from "@atlaskit/icon/core/comment";
import AddIcon from "@atlaskit/icon/core/add";
import EditIcon from "@atlaskit/icon/core/edit";
export const JiraUIRenderType = {
  JIRA_COMMENT: "JIRA_COMMENT",
  JIRA_CREATE_ISSUE: "JIRA_CREATE_ISSUE",
  JIRA_UPDATE_ISSUE: "JIRA_UPDATE_ISSUE",
};

export const getJiraRenderOptions = (renderOptions) => {
  if (renderOptions.find((o) => o.label === "Jira (Templates)") === undefined) {
    renderOptions.push({
      label: "Jira (Templates)",
      options: [
        {
          label: (
            <div>
              <span className="create-dropdown-icon">
                <AddIcon label="" />
              </span>
              &nbsp;Create Issue
            </div>
          ),
          value: JiraUIRenderType.JIRA_CREATE_ISSUE,
          title: "Create Issue",
        },
        {
          label: (
            <div>
              <span className="create-dropdown-icon">
                <EditIcon label="" />
              </span>
              &nbsp;Update Issue
            </div>
          ),
          value: JiraUIRenderType.JIRA_UPDATE_ISSUE,
          title: "Update Issue",
        },
        {
          label: (
            <div>
              <span className="create-dropdown-icon">
                <CommentIcon label="" />
              </span>
              &nbsp;Issue Comment
            </div>
          ),
          value: JiraUIRenderType.JIRA_COMMENT,
          title: "Issue Comment",
        },
      ],
    });
  }
};
export const addJiraActionData = (action) => {
  if (action.uiRenderer === JiraUIRenderType.JIRA_COMMENT) {
    action.url = "{{baseUrl}}/rest/api/3/issue/{{issueIdOrKey}}/comment";
    action.method = "POST";
    action.variables = [{ key: "issueIdOrKey", value: "$.issue.key" }];
    action.credentialsReference = { value: ATLASSIAN_AUTH_TOKEN, type: CredentialsReferenceType.ATLASSIAN_TOKEN };
  } else if (action.uiRenderer === JiraUIRenderType.JIRA_CREATE_ISSUE) {
    action.url = "{{baseUrl}}/rest/api/3/issue";
    action.method = "POST";
    action.credentialsReference = { value: ATLASSIAN_AUTH_TOKEN, type: CredentialsReferenceType.ATLASSIAN_TOKEN };
  } else if (action.uiRenderer === JiraUIRenderType.JIRA_UPDATE_ISSUE) {
    action.url = "{{baseUrl}}/rest/api/3/issue/{{issueIdOrKey}}";
    action.method = "PUT";
    action.variables = [{ key: "issueIdOrKey", value: "$.issue.key" }];
    action.credentialsReference = { value: ATLASSIAN_AUTH_TOKEN, type: CredentialsReferenceType.ATLASSIAN_TOKEN };
  }
  return action;
};

export const NON_EDITABLE = [
  "resolutiondate",
  "workratio",
  "issuerestriction",
  "thumbnail",
  "updated",
  "timeoriginalestimate",
  "attachment",
  "progress",
  "votes",
  "timespent",
  "issuetype",
  "worklog",
  "aggregatetimeestimate",
  "statuscategorychangedate",
  "lastViewed",
  "statusCategory",
  "issuekey",
  "aggregatetimeoriginalestimate",
  "comment",
  "aggregatetimespent",
  "aggregateprogress",
  "creator",
  "timeestimate",
];
